// src/components/LandingMarketTable.js

import React, { useEffect, useMemo, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import './LandingMarketTable.css';

const SYMBOLS = [
  'AAPL','TSLA','AMZN','MSFT','NVDA','GOOGL','META','NFLX','JPM','V','BAC',
  'PYPL','DIS','T','PFE','COST','INTC','KO','TGT','NKE','SPY'
];

function formatNumber(n) {
  if (n == null) return '—';
  if (n >= 1e12) return `${(n / 1e12).toFixed(1)}T`;
  if (n >= 1e9) return `${(n / 1e9).toFixed(1)}B`;
  if (n >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  return n.toLocaleString();
}

function toNum(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

export default function LandingMarketTable({ marketFilter = 'largest' }) {
  const [rows, setRows] = useState([]);
  // const navigate = useNavigate();

  useEffect(() => {
    Promise.all(
      SYMBOLS.map((symbol) =>
        fetch(`/data/${symbol}/landing.json`)
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null)
      )
    ).then((data) => {
      setRows(data.filter(Boolean));
    });
  }, []);

  const displayedRows = useMemo(() => {
    const copy = [...rows];

    if (marketFilter === 'winners') {
      copy.sort((a, b) => (toNum(b.changePercent) ?? -Infinity) - (toNum(a.changePercent) ?? -Infinity));
      return copy.slice(0, 20);
    }

    if (marketFilter === 'losers') {
      copy.sort((a, b) => (toNum(a.changePercent) ?? Infinity) - (toNum(b.changePercent) ?? Infinity));
      return copy.slice(0, 20);
    }

    // default: largest companies by market cap
    copy.sort((a, b) => (toNum(b.marketCap) ?? -Infinity) - (toNum(a.marketCap) ?? -Infinity));
    return copy.slice(0, 20);
  }, [rows, marketFilter]);

  return (
    <div className="landing-market-table">
      <table>
        <thead>
          <tr>
            <th>Stock</th>
            <th>Price</th>
            <th>Change</th>
            <th>Market Cap</th>
            <th>Volume</th>
          </tr>
        </thead>
        <tbody>
          {displayedRows.map((row) => {
            const price = toNum(row.price);
            const changePercent = toNum(row.changePercent);

            return (
              <tr
                key={row.symbol}
                // onClick={() => navigate(`/visualization?symbol=${row.symbol}`)}
              >
                <td className="symbol-cell">
                  <strong>{row.symbol}</strong>
                  <span>{row.name}</span>
                </td>

                <td>{price == null ? '—' : `$${price.toFixed(2)}`}</td>

                <td className={(changePercent ?? 0) >= 0 ? 'pos' : 'neg'}>
                  {changePercent == null ? '—' : `${changePercent.toFixed(2)}%`}
                </td>

                <td>{formatNumber(row.marketCap)}</td>
                <td>{formatNumber(row.volume)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
